import { Base } from './Base';

const body = document.body;

const classes = {
  customTheme: 'theme-custom',
}

export class Hero extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.init();
  }

  init() {
    const { primaryColor, secondaryColor } = this.element.dataset;
    this.setCustomColors(primaryColor, secondaryColor);
    
  }
  
  hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? `${parseInt(result[1], 16)},${parseInt(result[2], 16)},${parseInt(result[3], 16)}` : null;
  }

  setCustomColors(primary, seconday) {
    if(primary && seconday) {
      if(primary !== 'rgba(0,0,0,0)') {
        body.classList.add(classes.customTheme);
        body.style.setProperty('--custom-header-primary-color', primary);
        
        //Used in CSS rgba properties
        body.style.setProperty('--custom-header-primary-color--rgb', this.hexToRgb(primary));

        if(seconday !== 'rgba(0,0,0,0)') {
          body.style.setProperty('--custom-header-secondary-color', seconday);
        }
      } else {
        body.classList.remove(classes.customTheme);
      }
    }
  }
}